import axios from "@/utils/request.js";
// 文生图
export const txt2img = (data) => {
  return axios.request({
    url: "/sd1.php",
    method: "post",
    data,
  });
};

// 图生图
export const img2img = (data) => {
  return axios.request({
    url: "/sd2.php",
    method: "post",
    data,
  });
};

// 配置
export const sdSetting = (data) => {
  return axios.request({
    url: "/sd3.php",
    method: "post",
    data,
  });
};
